import { createLoadableList } from 'external/immutability-helper'
import create, {initializeAndRegisterHooks} from 'context/create' 
import triggers, * as resolves from './triggers'
import { AccountingState } from 'types/context/accounting'

const id = 'Accounting'

export const initialState: AccountingState = {
    payouts: createLoadableList(),
    payoutsPaging: false,
    payout: {
        loading: false,
        id: false,
        data: false
    },
}

const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, triggers, resolves)})
export {context as default}